<div class="po-row" id="over-login">
  <div class="login po-sm-12 po-md-12 po-lg-6 po-xl-6 login-container" id="mfa">
    <po-page-login [p-background]="background" [p-contact-email]="contactEmail" [p-custom-field]="customField"
      [p-environment]="environment" [p-exceeded-attempts-warning]="exceededAttempts"
      [p-hide-remember-user]="properties.includes('hideRememberUser')" [p-loading]="properties.includes('loading')"
      [p-literals]="customLiterals" [p-login]="login" [p-login-errors]="loginErrors" [p-login-pattern]="loginPattern"
      [p-logo]="logo" [p-password-errors]="passwordErrors" [p-password-pattern]="passwordPattern"
      [p-product-name]="productName" [p-register-url]="registerUrl" [p-secondary-logo]="secondaryLogo"
      [p-support]="support" [p-languages]="languages" (p-login-submit)="loginSubmit($event)">
    </po-page-login>
    <po-modal #modal p-title="Múltiplo fator de autenticação (MFA)" id="mfa-modal"> 
      <po-password #mfaValue name="input" [p-maxlength]="6" p-label="Informe o número de autenticação"> </po-password>
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-d-flex center-button" id="button-mfa">
          <po-button
              class="po-mr-1"
              (p-click)="addMfaValue(mfaValue)"
              p-label="Confirmar"
            ></po-button>
          <po-button
            class="po-ml-1"
            (p-click)="closeModal()"
            p-label="Cancelar"
          ></po-button>
        </div>
      </div>
    </po-modal>
    <div class="sample-container" *ngIf="show">
      <po-loading-overlay></po-loading-overlay>
    </div>
  </div>
  <div class="po-sm-6 po-md-6 po-lg-6 po-xl-6 login-side-image" id="picture">
    <div id="over"></div>
    <div id="slogan">
      <span>As informações da sua empresa em um só lugar!</span>
    </div>
  </div>  
</div>